import React, { Component } from 'react';
import './styles.scss';

class AdminFooter extends Component {
	render() {
		return (
			<div className="AdminFooter">
			</div>
		);
	}
}

export default AdminFooter;
